import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem("userInfo", JSON.stringify(action.payload));
    },
    logout: (state, action) => {
      try {
        state.userInfo = null;
        localStorage.removeItem("userInfo");
        if (localStorage.getItem("userInfo") !== null) {
          localStorage.removeItem("userInfo");
          state.userInfo = null;
        }
      } catch (e) {
        localStorage.removeItem("userInfo");
        state.userInfo = null;
      }
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
